import { Alert, AlertProps, Typography } from "@outschool/backpack";
import React from "react";

interface NoticeProps {
  severity?: AlertProps["severity"];
  title: React.ReactElement;
  description?: React.ReactElement;
}

/**
 * A hook which allows you to temporarily display an <Alert />
 */
export default function useAlertNotice() {
  const [noticeProps, setNotice] = React.useState<NoticeProps | undefined>();
  return {
    setNotice,
    clearNotice: React.useCallback(() => {
      setNotice(undefined);
    }, []),
    notice: noticeProps ? (
      <Alert
        severity={noticeProps.severity ?? "success"}
        sx={{ marginBottom: "1em" }}
      >
        <Typography variant="h6" sx={{ display: "block" }}>
          {noticeProps.title}
        </Typography>
        <Typography variant="body2" sx={{ display: "block" }}>
          {noticeProps.description}
        </Typography>
      </Alert>
    ) : null,
  };
}
